import { getParamFromUrl } from 'utils/helpers';

window.addEventListener('load', () => {
  // If there is date parameter in the url, show the offcanvas directly
  const bookingDrawer = document.querySelector('[data-booking-drawer]');
  if (bookingDrawer) {
    const date = getParamFromUrl('date');
    if (date) {
      const bsOffcanvas = new window.BsOffcanvas(bookingDrawer);
      bsOffcanvas.show();
    }
  }
});
